
export function checkCode(rule, value, callback) {
    if (!value) {
        return callback(new Error('不能为空'));
    }
    let note = value.replace(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/g, "")
    if (value !== note) {
        callback(new Error('请输入数字或英文字母'));
    } else {
        callback();
    }
}

export function checkSort(rule, value, callback) {
    setTimeout(() => {
        if (value.length === 0) {
            // return callback(new Error('不能为空'));
            callback();
        }
        if (!Number.isInteger(value)) {
            callback(new Error('请输入正确序号'));
        } else {
            callback();
        }
    }, 100);
}
export function checkNumber(rule, value, callback) {
    let note = value.replace(/^[0-9]+\.?[0-9]*$/g, "")
    let numNote = Number(note)
    console.log(note)
    console.log(numNote)
    if (Number(note) < -1 || numNote == NaN) {
        callback(new Error('请输入数字'));
    } else {
        callback();
    }
}
/*
export function checkNumber(rule, value, callback) {
    console.log(typeof value, value)
    if (!value) {
        return callback(new Error('不能为空'));
    }
    setTimeout(() => {
        if (!Number.isInteger(value)) {
            callback(new Error('请输入数字值'));
        } else {
            callback();
        }
    }, 500);
}
 */